import styled from 'styled-components';

export const Container = styled.div`
  float: left;
  display: flex;
  flex-direction: row;
  width: 100%;
  padding: 20px;
  align-items: center;

  i {
    float: left;
  }

  h1 {
    margin-left: 0.7rem;
    font-size: 1rem;
    font-weight: 700;
    color: ${({ theme }) => theme.colors.TEXT1};
  }

  h2 {
    margin-left: 0.7rem;
    font-size: 12px;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.TEXT3};
  }

  main {
    display: flex;
    flex-direction: column;
  }

  > div {
    flex-direction: row;
    flex: 1;
    justify-content: flex-end;
    display: flex;

    button {
      display: flex;
      padding: 8px 15px 8px 15px;
      border: ${({ theme }) => `1px solid ${theme.colors.BORDER}`};
      border-radius: 8px;
      margin-left: 5px;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      cursor: pointer;
      transition: all 0.5s ease;

      &:hover {
        background: #333 !important;
      }

      &.excel {
        background: #179d46;
      }

      &.pdf {
        background: #df4c2a;
      }

      &.sync {
        background: #4080e0ff;
      }

      &.inload {
        cursor: progress;
        background: #000;
        opacity: 0.9;
      }
      div {
        display: flex;
        flex-direction: column;
        padding: 0 0 0 5px;

        h3 {
          font-size: 8px;
          text-align: left;
          font-weight: normal;
          color: ${({ theme }) => theme.colors.TEXT2};
          margin: 0px;
        }

        h2 {
          font-size: 12px;
          text-align: left;
          color: ${({ theme }) => theme.colors.TEXT2};
          margin: 0px;
          font-weight: 700;
        }
      }
    }
  }

  @media (max-width: 1024px) {
    
    width: 100%;
    padding: 15px 10px;
    background: ${({ theme }) => theme.colors.LIGHT1};

    h1 {
      font-size: 10px;
    }

    > div {
      button {
        padding: 5px 10px 5px 3px;

        div {
          h3 {
            font-size: 8px;
          }

          h2 {
            font-size: 10px;
          }
        }
      }
    }
  }
`;
